const docTemplates = {
  searchTemplates: "Поиск шаблонов...",
  newTemplate: "Новый шаблон",
  noTemplates: "Нет шаблонов",
  createFirst: "Создать первый шаблон",
  untitledTemplate: "Шаблон без названия",
  total: "Всего",
  backToPipeline: "Назад к очереди",
  backToTemplates: "Назад к шаблонам",
  templateNotFound: "Шаблон не найден",
  allStatuses: "Все статусы",
  statusDraft: "Черновик",
  statusActive: "Активный",
  statusArchived: "Архив",
  duplicate: "Дублировать",
  archive: "Архивировать",
  copy: "копия",
  addDescription: "Добавить описание...",
  addTag: "Тег...",
  saveVersion: "Сохранить версию",
  manageTemplates: "Управление шаблонами",
  useTemplate: "Из шаблона",
  selectTemplate: "Выбрать шаблон",
  blankDocument: "Пустой документ",
  orBlank: "или создать пустой документ",
  startFromScratch: "Начать с нуля без шаблона",
} as const;
export default docTemplates;
